import styled from '@emotion/styled';
import { Avatar, Box } from '@mui/material';
import { MENU_USER_AVATAR_BACKGROUND_COLOR, MENU_USER_AVATAR_COLOR } from '../../themes/tokens';

export const LogoWrapper = styled(Box)`
  margin-right: 16px;
  height: 24px;
  cursor: pointer;
`;

export const MenuUserAvatar = styled(Avatar)`
  width: 40px;
  height: 40px;
  color: ${MENU_USER_AVATAR_COLOR};
  background-color: ${MENU_USER_AVATAR_BACKGROUND_COLOR};
`;

export const StyledImage = styled.img`
  width: 100%;
`;
